module.exports = __webpack_public_path__ + "static/media/IconNoneGray.2c86aab7.svg";